import {isNullOrUndefined} from "../../../services/Validator";

function AboutDesktopLayout({children}) {
    // Used in AboutScreen to frame element in desktop mode

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"overflow-auto bg-backgroundLight3 w-full grow hidden sm:flex sm:flex-col justify-start items-center"}>
            {children}
        </div>
    );
}

// EXPORT
export default AboutDesktopLayout